import styled from 'styled-components';

export const StarImage = styled.div`
  font-size: 25px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 18px;
  }
`;
